import React from "react";
import {  CircularProgress } from "@material-ui/core";

const CircularLoader = ({size,style}) => {
    return (    
        <CircularProgress size={size || 14} style={style || {marginRight : '5px',color:'#555956a6'}} />
    )
}

export default CircularLoader;